export const paymentOptions = [
  {name: "Chargebee", className: "chargebee", selected: true, order: 1},
  {name: "Paypal", className: "paypal", selected: false, order: 2},
  {name: "Bank", className: "bank", selected: false, order: 3},
];
